var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8H5a.2.2 0 0 0-.2.2v1c0 .11.09.2.2.2h5a.2.2 0 0 0 .2-.2v-1a.2.2 0 0 0-.2-.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.8H4c-1.21 0-2.2.99-2.2 2.2v10c0 1.21.99 2.2 2.2 2.2h14c1.21 0 2.2-.99 2.2-2.2V6c0-1.21-.99-2.2-2.2-2.2ZM3.2 9.2h15.6V16c0 .44-.36.8-.8.8H4c-.44 0-.8-.36-.8-.8V9.2Zm15.6-1.4H3.2V6c0-.44.36-.8.8-.8h14c.44 0 .8.36.8.8v1.8Z",
    fill: "currentColor"
  })));
};
export default SvgCreditCard;